// extracted by mini-css-extract-plugin
export var chevron = "_1o-d";
export var disabled = "_1o-b";
export var error = "_1o-c";
export var hideBorder = "_1o-1";
export var icon = "_1o-e";
export var input = "_1o-0";
export var large = "_1o-f";
export var open = "_1o-9";
export var placeholder = "_1o-a";
export var regular = "_1o-5";
export var singleRowInput = "_1o-2";
export var singleSelectInput = "_1o-3 _1o-0";
export var small = "_1o-4";
export var spinnerContainer = "_1o-i";
export var tag = "_1o-7";
export var tagsContainer = "_1o-8";
export var tagsInput = "_1o-6 _1o-0";
export var xSmall = "_1o-g";
export var xxSmall = "_1o-h";